import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Wrapper = styled.div`
  ${({theme}) => css`
    align-items: center;
    background-color: rgba(235, 87, 87, 0.1); // theme.colors.red at 0.1 opacity
    border: 0.5px solid rgba(235, 87, 87, 0.5); // theme.colors.red at 0.5 opacity
    border-radius: 6px;
    color: ${theme.colors.red};
    display: flex;
    margin-bottom: 20px;
    padding: 6.5px 10px;

    svg {
      height: 12px;
      margin-right: 8px;
    }
  `}
`;

export const Message = styled.p`
  font-size: 11px;
`;
